import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import { __awaiter, __generator, __values } from "tslib";
import Vue from 'vue';
import { dateToday, getYear, getMonth, isUndef } from '@/lib/utils';
var m = {
  namespaced: true,
  state: function state() {
    return {
      signInData: null,
      signInMap: {},
      calendarCached: {},
      detail: {},
      rejectedDetail: {},
      badgesIds: null,
      countCard: null,
      signInAd: [],
      calendarCardMap: {},
      hasCalendarCardMap: {},
      weekData: {},
      echartsData: {},
      updateAvatarArrMap: {}
    };
  },
  mutations: {
    setSignInData: function setSignInData(state, data) {
      state.signInData = data;
    },

    /** 填充打卡日历数据 */
    setSignIn: function setSignIn(state, _a) {
      var date = _a.date,
          signIn = _a.signIn;
      Vue.set(state.signInMap, date, signIn);
    },

    /**
     * 记录日历是否已经加载
     */
    setCalendarCached: function setCalendarCached(state, _a) {
      var month = _a.month,
          cached = _a.cached;
      Vue.set(state.calendarCached, month, cached);
    },

    /**
     * 记录detail
     */
    setDetail: function setDetail(state, _a) {
      var signInId = _a.signInId,
          detail = _a.detail;
      Vue.set(state.detail, signInId, detail);
    },

    /**
     * 记录不通过打卡详情
     */
    setRejectedDetail: function setRejectedDetail(state, _a) {
      var signInId = _a.signInId,
          detail = _a.detail;
      Vue.set(state.rejectedDetail, signInId, detail);
    },

    /**
     * 设置点亮的勋章的ids
     */
    setBadgesIds: function setBadgesIds(state, ids) {
      state.badgesIds = ids;
    },

    /**
     * 设置获得的次数卡
     */
    setCountCard: function setCountCard(state, card) {
      state.countCard = card || null;
    },

    /** 存储打卡页广告 */
    setSignInAd: function setSignInAd(state, ads) {
      state.signInAd = ads;
    },

    /** 存储日历卡 */
    setCalendarCardMap: function setCalendarCardMap(state, _a) {
      var month = _a.month,
          url = _a.url;
      Vue.set(state.calendarCardMap, month, url);
    },

    /** 存储日历卡 */
    setHasCalendarCardMap: function setHasCalendarCardMap(state, _a) {
      var month = _a.month,
          status = _a.status;
      Vue.set(state.hasCalendarCardMap, month, status);
    },

    /** 储存周运动数据 */
    setWeekData: function setWeekData(state, _a) {
      var id = _a.id,
          weekData = _a.weekData;
      Vue.set(state.weekData, id, weekData);
    },

    /** 储存周运动数据图表 */
    setEchartsData: function setEchartsData(state, _a) {
      var id = _a.id,
          type = _a.type,
          echartsData = _a.echartsData;
      Vue.set(state.echartsData, type + id, echartsData);
    },
    updateAvatarArr: function updateAvatarArr(state, data) {
      state.updateAvatarArrMap = data;
    }
  },
  actions: {
    /**
     * 创建打卡
     * @param participationId 允许为空
     */
    create: function create(_a, _b) {
      var state = _a.state,
          commit = _a.commit,
          dispatch = _a.dispatch;
      var image = _b.image,
          time = _b.time,
          distance = _b.distance,
          crossCountryRun = _b.crossCountryRun;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, today, month;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/create_sign_in', {
                image: image,
                time: time,
                distance: distance,
                cross_country_run: crossCountryRun
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              if (!(rdata.status === 0)) return [3
              /*break*/
              , 3];
              commit('setBadgesIds', rdata.data.medal_ids);
              commit('setCountCard', rdata.data.count_card);
              today = dateToday();
              month = getYear(today) + "-" + (getMonth(today) + 1);
              return [4
              /*yield*/
              , Promise.all([state.signInData ? dispatch('getSignInData', {
                forceUpdate: true
              }) : '', state.calendarCached[month] ? dispatch('getCalendar', {
                month: month,
                forceUpdate: true
              }) : ''])];

            case 2:
              _c.sent();

              _c.label = 3;

            case 3:
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取打卡数据
     */
    getSignInData: function getSignInData(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var forceUpdate = (_b === void 0 ? {} : _b).forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.signInData && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/sign_in_data')];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setSignInData', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 按月份获取打卡数据
     * @param month 格式2018-01
     */
    getCalendar: function getCalendar(_a, _b) {
      var state = _a.state,
          commit = _a.commit;

      var _c = _b === void 0 ? {} : _b,
          month = _c.month,
          forceUpdate = _c.forceUpdate;

      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, _d, _e, signIn;

        var e_1, _f;

        return __generator(this, function (_g) {
          switch (_g.label) {
            case 0:
              if (state.calendarCached[month] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/sign_in_calendar', {
                params: {
                  month: month
                }
              })];

            case 1:
              response = _g.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                try {
                  for (_d = __values(rdata.data), _e = _d.next(); !_e.done; _e = _d.next()) {
                    signIn = _e.value;
                    commit('setSignIn', {
                      date: signIn.date,
                      signIn: signIn
                    });
                    commit('setCalendarCached', {
                      month: month,
                      cached: true
                    });
                  }
                } catch (e_1_1) {
                  e_1 = {
                    error: e_1_1
                  };
                } finally {
                  try {
                    if (_e && !_e.done && (_f = _d["return"])) _f.call(_d);
                  } finally {
                    if (e_1) throw e_1.error;
                  }
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取打卡详情
     */
    getDetail: function getDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var signInId = _b.signInId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/sign_in_detail', {
                params: {
                  id: signInId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setDetail', {
                  signInId: signInId,
                  detail: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取不通过的打卡详情
     */
    getRejectedDetail: function getRejectedDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var signInId = _b.signInId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/rejected_sign_in_detail', {
                params: {
                  sign_in_id: signInId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setRejectedDetail', {
                  signInId: signInId,
                  detail: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取打卡页底部广告
     */
    getSignInAd: function getSignInAd(_a, forceUpdate) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, data;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (state.signInAd && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/framework/sign_in_ads')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('setSignInAd', data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    // 修改亲子图片
    editImgParentAvatar: function editImgParentAvatar(_a, _b) {
      var commit = _a.commit;
      var activity_id = _b.activity_id,
          activity_special_id = _b.activity_special_id,
          user_id = _b.user_id,
          parent_child_avatar = _b.parent_child_avatar;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/upload_parent_child_avatar', {
                activity_id: activity_id,
                activity_special_id: activity_special_id,
                user_id: user_id,
                parent_child_avatar: parent_child_avatar
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              ];
          }
        });
      });
    },

    /**
     * 打卡申诉
     */
    postSignInAppeal: function postSignInAppeal(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var signInId = _b.signInId,
          reason = _b.reason;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/sign_in_appeal', {
                sign_in_id: signInId,
                reason: reason
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取日历卡
     */
    getCalendarCard: function getCalendarCard(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var month = _b.month,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (state.calendarCardMap[month] && !forceUpdate) {
                return [2
                /*return*/
                , {
                  status: 0,
                  data: {
                    url: state.calendarCardMap[month],
                    finished: true
                  }
                }];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/calendar_card', {
                params: {
                  month: month
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0 && rdata.data.finished) {
                commit('setCalendarCardMap', {
                  month: month,
                  url: rdata.data.url
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 当前月份是否存在日历卡
     */
    checkHasCalendarCard: function checkHasCalendarCard(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var month = _b.month;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!isUndef(state.hasCalendarCardMap[month])) {
                return [2
                /*return*/
                , {
                  status: 0,
                  data: state.hasCalendarCardMap[month]
                }];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/month_has_card', {
                params: {
                  month: month
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setHasCalendarCardMap', {
                  month: month,
                  status: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得成就卡
     */
    getCustomSignInCard: function getCustomSignInCard(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var signInId = _b.signInId,
          content = _b.content,
          bg = _b.bg;
      return __awaiter(this, void 0, void 0, function () {
        var params, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              params = {
                id: signInId
              };

              if (content) {
                params.string = content;
              }

              if (bg) {
                params.bg = bg;
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/custom_sign_in_card', {
                params: params
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取打卡页本周上周数据
     */
    getWeekData: function getWeekData(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var id = _b.id;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity_match_rank/week_data', {
                params: {
                  id: id
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setWeekData', {
                  id: id,
                  weekData: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取打卡页本周上周数据
     */
    getEchartsData: function getEchartsData(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var id = _b.id,
          type = _b.type;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.echartsData[type + id]) {
                return [2
                /*return*/
                , state.echartsData[type + id]];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity_match_rank/echarts_data', {
                params: {
                  id: id,
                  type: type
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setEchartsData', {
                  id: id,
                  type: type,
                  echartsData: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 将本次打卡数据隐藏
     */
    deleteSignIn: function deleteSignIn(_a, signInId) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/delete_sign_in', {
                params: {
                  id: signInId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    //  获取用户头像
    updateAvatar: function updateAvatar(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          userId = _b.userId,
          activityspecialId = _b.activityspecialId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('api/v1/participationbind_avatar', {
                params: {
                  activity_id: activityId,
                  user_id: userId,
                  activity_special_id: activityspecialId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                console.log(rdata, '333333333333333');
                commit('updateAvatarArr', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;